<template>
  <v-container>
    <v-row>
      <MobileCol>
        <v-skeleton-loader
          :loading="isLoading"
          transition="expand-transition"
          type="article"
        >
          <div>
            <h1>{{ $$t('title') }}</h1>
            <div v-if="myLocation" v-html="myLocation.leaderContact">
              <div class="d-flex justify-end mb-6">
              </div>
            </div>
            <back-button />
          </div>
        </v-skeleton-loader>
      </MobileCol>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import location from '../mixins/location';
import MobileCol from '../components/MobileCol.vue';
import BackButton from '../components/BackButton.vue';

export default {
  mixins: [location, loading],
  components: {
    MobileCol,
    BackButton,
  },
  name: 'Leader',
  module: 'Membership',
  data() {
    return {
      /**
      * Get/Set editing Leader. Default to {}.
      */
      editLeader: {},
      /**
       * Query Id for Leader
       */
      leaderId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('mapItems', ['myLocation']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.leaderId) {
        return 'edit';
      }
      return 'add';
    },
  },
  created() {
    this.$on('location.changed', this.locationChanged);
  },
  destroyed() {
    this.$off('location.changed');
  },
  async mounted() {
    this.isLoading = true;
    await this.refresh();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('mapItems', ['LOAD_myLocation']),
    async locationChanged(pos) {
      this.localMyLocation = await this.LOAD_myLocation({
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      });
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# EditLeader example

'''js
<EditLeader :Leader="Leader" />
'''
</docs>
